import React, {Fragment, useEffect} from 'react';

import '../../App.css';
import {Outlet, useMatches, useNavigate, useParams} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "../../feature/tools";
import {Button, Col, Flex, Modal, Row, Segmented, Space, Tooltip} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAngleLeft, faGrip, faList, faPlus} from "@fortawesome/free-solid-svg-icons";
import {AddSceneModal} from "./AddSceneModal";
import {Status} from "../../feature/project/status";
import {Scene} from "../../feature/project/story";
import {ViewMode} from "../common/ViewMode";
import {useCookies} from "react-cookie";
import {deleteScene, fetchScene, saveScene} from "../../feature/project/sceneSlice";
import Shots from "../shot/Shots";
import {AddShotModal} from "../shot/AddShotModal";
import {fetchShots, saveShot} from "../../feature/project/shotSlice";
import {EntityDetails} from "../common/EntityDetails";
import {Shot} from "../../feature/project/Shot";
import Title from "antd/es/typography/Title";
import {editorRoles, WithUserPermission} from "../common/WithUserPermission";

const {confirm} = Modal
const SceneDetails = () => {

    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const {actId, projectId, storyId, chapterId, sceneId} = useParams()
    const scene = useAppSelector(state => state.scenes.scene)
    const project = useAppSelector(state => state.projects.project)
    const status = useAppSelector(state => state.scenes.status)
    const shotsStatus = useAppSelector(state => state.shots.status)
    const [modal, setModal] = React.useState(false)
    const [shotModal, setShotModal] = React.useState(false)
    const matches = useMatches()

    useEffect(() => {
        if (projectId && sceneId && (status == Status.Idle || scene?.id !== parseInt(sceneId))) {
            dispatch(fetchScene({projectId: parseInt(projectId), sceneId: parseInt(sceneId)}))
        }
    }, [status, projectId, sceneId, dispatch])


    useEffect(() => {
        if (projectId && sceneId && (shotsStatus === Status.Idle || scene?.id !== parseInt(sceneId))) {
            dispatch(fetchShots({projectId: parseInt(projectId), sceneId: parseInt(sceneId)}))
        }
    }, [shotsStatus, projectId, storyId, dispatch])


    const showDeleteConfirm = () => {
        confirm({
            title: 'Delete Scene',
            content: 'Are you sure you want to delete this scene?',
            icon: <></>,
            okText: 'Yes, delete',
            okButtonProps: {danger: true, type: 'primary'},
            cancelText: 'No',
            onOk() {
                if (!sceneId || !projectId) return
                dispatch(deleteScene({projectId: parseInt(projectId), sceneId: parseInt(sceneId)}))
                navigate(`/projects/${projectId}/stories/${storyId}/acts/${actId}/chapters/${chapterId}`)
            },
        });
    };

    return (
        <Fragment>{
            matches[matches.length - 1].pathname.includes('/shots') ? <Outlet/> : <>
                <Row style={{height: "100%"}}>
                    <Col span={scene ? 16 : 24} style={{height: "100%"}}>
                        <Flex justify={'space-between'}>

                            <Space>
                                <Button type={'text'}
                                        onClick={() => navigate(`/projects/${projectId}/stories/${storyId}/acts/${actId}/chapters/${chapterId}`)}
                                        icon={<FontAwesomeIcon icon={faAngleLeft}/>}/>
                                <Title level={4} style={{margin: 0}}>Shots</Title>

                            </Space>
                            <WithUserPermission roles={editorRoles}>
                            <Space>
                                <Tooltip title="Add Shot">
                                    <Button icon={<FontAwesomeIcon icon={faPlus}/>} onClick={() => setShotModal(true)}>Add
                                        Shot</Button>
                                </Tooltip>
                            </Space>
                            </WithUserPermission>
                        </Flex>
                        <Shots/>
                    </Col>
                    {scene ? <Col span={8} style={{height: "100%"}}>
                        <EntityDetails
                            simple={true}
                            entity={scene}
                            onDeleteClick={() => {
                                showDeleteConfirm()
                            }}
                            onEditClick={() => setModal(true)}
                        />
                    </Col> : ''}
                </Row>
                {scene ?
                    <AddSceneModal
                        scene={scene}
                        visible={modal}
                        onCancel={() => setModal(false)}
                        onSave={(scene: Scene) => {
                            if (project) {
                                dispatch(saveScene({projectId: project.id, scene: scene}))
                            }
                            setModal(false)
                        }}
                    /> : ''}
                <AddShotModal
                    shot={{
                        title: '',
                        environment: 'Interior',
                        time: 'Day',
                        place: '',
                        description: '',
                        cover: '',
                        tags: [],
                        actions: [],
                        shots: []
                    }}
                    visible={shotModal}
                    onCancel={() => setShotModal(false)}
                    onSave={(shot: Shot) => {
                        if (project && sceneId) {
                            shot.sceneId = parseInt(sceneId)
                            dispatch(saveShot({projectId: project.id, shot: shot}))
                        }
                        setShotModal(false)
                    }}
                />
            </>
        }
        </Fragment>
    );
};

export default SceneDetails;